var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"chart-holder-line",staticStyle:{"color":"#000"}},[_c('bar-chart',{attrs:{"data":_vm.specialty,"colors":_vm.colors,"height":"300px","width":"100%","library":_vm.options}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }